require('../../styles/blocks/_errors-screen.scss');
const React = require('react');

class ErrorsScreen extends React.Component {
    constructor(props) {
        super(props);

        document.body.style.background = '#fff';
    }

    render() {
        const { iconClass, title, subtitle, action, buttonText, buttonClass } = this.props;

        return (
            <div className="errors-container">
                <i className={iconClass}></i>
                <h2 className="font-heading2">{title}</h2>
                <p className="font-paragraph1">{subtitle}</p>
                <a href="#" className={buttonClass} onClick={action}>
                    {buttonText}
                </a>
            </div>
        );
    }
}

ErrorsScreen.defaultProps = {
    iconClass: 'icon',
    title: '',
    subtitle: '',
    action: null,
    buttonText: '',
    buttonClass: 'form__button form__button-secondary',
    style: {},
};
module.exports = ErrorsScreen;
